import { useState, useEffect } from "react";

// Appends Forms2 script to the DOM
const appendScript = (baseUrl, setScriptLoaded) => {
    // If the script is already loaded, return
    if (window.MktoForms2) return setScriptLoaded(true);

    const script = document.createElement("script");
    script.src = `${baseUrl}/js/forms2/js/forms2.min.js`;
    script.onload = () => (window.MktoForms2 ? setScriptLoaded(true) : null);
    document.body.appendChild(script);

    // Otherwise, append the script to the DOM
    return true;
};

// Hook which appends MarketoForms2 script if not present, otherwise will load the form
export const useMarketoForm = ({ formId, callback, renderFunction }) => {
    const baseUrl = `${process.env.GATSBY_MARKETO_BASE_URL}`;
    const munchkinId = `${process.env.GATSBY_MARKETO_MUNCHKIN_ID}`;
    const [scriptLoaded, setScriptLoaded] = useState(false);
    const [formLoaded, setFormLoaded] = useState(false);

    // Load the script
    useEffect(() => {
        if (!scriptLoaded) {
            // Otherwise, load the script and set the scriptLoaded state to true
            appendScript(baseUrl, setScriptLoaded);
        }
    }, [scriptLoaded, baseUrl]);

    // Load the form
    useEffect(() => {
        // If the script is available and the form is not, load the form
        if (scriptLoaded && !formLoaded) {
            window.MktoForms2.loadForm(baseUrl, munchkinId, formId, callback);

            // If a render function is passed, call it when the form is rendered (and re-rendered/updated)
            renderFunction && window.MktoForms2.onFormRender(renderFunction);

            // Set the formLoaded state to true
            setFormLoaded(true);
        }
    }, [formLoaded, scriptLoaded, baseUrl, munchkinId, formId, callback, renderFunction]);
};
